/* date-constraints:
 *
 * Add constraints relative to current date, based on datatype name.
 *
 * Format of the datatype is as follows:
 *
 * date-constraints[^{]*{INNARDS OF JSON OBJECT}
 *
 * e.g. date-constraints{"minimum" : 0}
 *
 * or
 *
 * date-constraints-notnull{"minimum" : 0}
 *
 * To render calendar from today.
 *
 * Author: Niels Giesen
 * Copyright 2015 Berkeley Bridge
 *
 */
(function ($, document) {
  $(document).on("bb:preHandleData", function (event, data) {
    if (data.groups) {
      $.each(data.groups, function (_, group) {
        if (group.current)
          $.each(group.controls, function (_, control) {
            constrain(control);
          });
      });
    }
  });

  function constrain(control) {
    if (control.controltype === "grid") {
      $.each(control.columns, function (_, column) {
        constrain(column);
      });
    } else if (/^date-constraints/.test(control.datatype)) {
      var json;
      try {
        json = JSON.parse(
          control.datatype.substr(control.datatype.indexOf("{"))
        );
      } catch {
        // Swallow err
      } finally {
        if (json) {
          if (
            typeof json.maximum !== "undefined" &&
            typeof json.maximum === "number"
          )
            json.maximum = nDaysAheadAsJSONString(json.maximum);
          if (
            typeof json.minimum !== "undefined" &&
            typeof json.minimum === "number"
          )
            json.minimum = nDaysAheadAsJSONString(json.minimum);
          $.extend(control, json);
        }
      }
    }
  }

  function nDaysAheadAsJSONString(n) {
    var date = new Date();
    date.setDate(date.getDate() + n);
    return date.toISOString().substr(0, 10);
  }
})(jQuery, document);
